import { render, staticRenderFns } from "./SearchStoreArticles.vue?vue&type=template&id=091b1e23&"
import script from "./SearchStoreArticles.vue?vue&type=script&lang=ts&"
export * from "./SearchStoreArticles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports